<div mat-dialog-title>
  <h4>{{ 'properties.list.exportContracts' | translate }}
    <!-- <span [ngClass]="{ 'd-none': !model.subject }"> - {{ model.subject }}</span> -->
  </h4>
  <div class="text-muted dialog-subtitle">
  </div>
</div>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>

    <div *ngIf="documentArchive.length">
      <table class="table table-borderless table-striped">
        <thead>
          <th>{{ 'properties.documentsPage.docType' | translate }}</th>
          <th>{{ 'properties.structures.structure' | translate }}</th>
          <th>{{ 'properties.documentsPage.supplier' | translate }}</th>
          <th>{{ 'properties.documentsPage.date' | translate }}</th>
          <th>{{ 'properties.documentsPage.expiredDate' | translate }}</th>
          <th>{{ 'common.cta.printQr' | translate }}</th>
        </thead>
        <tbody>
          <tr *ngFor="let item of documentArchive">
            <td>{{ item.type }}</td>
            <td>{{ item.structureObjectName }}</td>
            <td>{{ item.data.ragioneSocialeFornitore }}</td>
            <td>{{ item.data.dataDocumento | dateDocumentFormat }}</td>
            <td>{{ item.dateExpired | date }}</td>
            <td><qrcode id="qr-img-{{ item.index }}" [qrdata]="item.qrcode" [width]="150" [errorCorrectionLevel]="'H'" [elementType]="'url'"></qrcode></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="documentArchive.length === 0">{{ 'properties.list.noExportContracts' | translate }}</div>

</mat-dialog-content> <!-- mat-dialog-content -->
<div mat-dialog-actions>
  <div class="row w-100 mt-4">
    <div class="col-12 col-md-6 text-left">
      <a mat-button (click)="onClose()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.close' | translate }}</a>
    </div> <!-- /.col -->
    <div class="col-12 col-md-6 text-right" *ngIf="documentArchive.length">
      <a mat-button (click)="onExportFile()" mat-raised-button mat-default
        class="ml-3" color="primary">{{ 'properties.dialog.getWordDocument' | translate }}</a>
    </div> <!-- /.col -->
  </div> <!-- /.row -->
</div>